import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import { setVal2Token, getUserInfoCompanyId, getUserInfo, getval2Token } from '../../../Login/Auth';
import { uuid } from '../../../../item/ItemTools';
import { SingleButton, Space, SingleLink } from '../../Res/BaseButton';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { Pagination } from '../../Res/Pagination';
import { RecruitmentPerformanceContractor } from './RecruitmentPerformanceContractor';
import { api_getRecruitmentPerformanceContractorRelatedList } from '../../../../api/apiRecruitmentPerformanceContractorRelated';
import { ReqRecruitmentPerformanceContractorRelatedList, RP_STATUS_CASEOWNER, KEY_STATUS_CASEOWNER } from '../../../../item/ItemRecruitmentPerformanceContractorRelated';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_RESERVE, CASE_STATUS_ONBOARD, CASE_STATUS_RESIGN } from '../../../../item/ItemRecruitmentContractor';

export function RecruitmentPerformanceContractorRelatedList({ id, setIsLoading, OnBoard, isEdit }) {
    const [tokenId, setTokenId] = useState("")

    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")
    const [companyId, setCompanyId] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [departmentId, setDepartmentId] = useState()
    const [departmentName, setDepartmentName] = useState()
    const [caseStatus, setCaseStatus] = useState("1")

    const [recruitmentPerformanceContractorRelatedList, setRecruitmentPerformanceContractorRelatedList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [reserveCount, setReserveCount] = useState(0)
    const [onBoardCount, setOnBoardCount] = useState(0)
    const [cancelCount, setCancelCount] = useState(0)
    const [resignCount, setResignCount] = useState(0)

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var obj = getval2Token(KEY_STATUS_CASEOWNER, id)
            console.log(obj)
            if (obj.companyId === undefined) {
                var userInfo = getUserInfo()
                console.log(userInfo)
                setCaseOwner(userInfo.accountId)
                setCaseOwnerName(userInfo.nickName)
                setCompanyId(userInfo.companyId)
                setCompanyName(userInfo.companyName)
                setDepartmentId(userInfo.departmentId)
                setDepartmentName(userInfo.departmentName)
                setVal2Token(KEY_STATUS_CASEOWNER, { 
                    caseOwner: userInfo.accountId, 
                    caseOwnerName: userInfo.nickName, 
                    companyId: userInfo.companyId, 
                    companyName: userInfo.companyName, 
                    departmentId: userInfo.departmentId, 
                    departmentName: userInfo.departmentName }, id)
            } else {
                // console.log(obj.caseOwnerj)
                setCaseOwner(obj.caseOwner)
                setCaseOwnerName(obj.caseOwnerName)
                setCompanyId(obj.companyId)
                setCompanyName(obj.companyName)
                setDepartmentId(obj.departmentId)
                setDepartmentName(obj.departmentName)
            }
            setTokenId(id)
        }
    }, [id])

    // useEffect(() => {
    //     //console.log(userInfo)
    //     setCaseOwner(userInfo.accountId)
    //     setCaseOwnerName(userInfo.nickName)
    //     setCompanyId(userInfo.companyId)
    //     setDepartmentId(userInfo.departmentId)
    // }, [userInfo])

    useEffect(() => {
        if (recruitmentPerformanceContractorRelatedList.length === 0 && caseOwner !== undefined && caseOwner !== ""  && departmentId !== "" && departmentId !== undefined && companyId !== "" && companyId !== undefined) {
            toReserve()
        }
    }, [caseOwner, departmentId, companyId])


    function toSearch({ item, page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        console.log(item)
        setPage(page)
        var mReqRecruitmentPerformanceContractorRelatedList = new ReqRecruitmentPerformanceContractorRelatedList({ companyId, caseOwner, caseStatus, start, limit })
        if (item !== undefined)
            mReqRecruitmentPerformanceContractorRelatedList.fromJson(item)
        //console.log(mReqRecruitmentPerformanceContractorRelatedList)
        getRecruitmentPerformanceContractorRelatedList(mReqRecruitmentPerformanceContractorRelatedList)
    }


    function getRecruitmentPerformanceContractorRelatedList(mReqRecruitmentPerformanceContractorRelatedList) {
        console.log(mReqRecruitmentPerformanceContractorRelatedList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getRecruitmentPerformanceContractorRelatedList({
            mReqRecruitmentPerformanceContractorRelatedList,
            success: (obj) => {
                console.log(obj)
                setRecruitmentPerformanceContractorRelatedList(obj.list)
                setCount(obj.count)
                setReserveCount(obj.reserveCount)
                setOnBoardCount(obj.onBoardCount)
                setCancelCount(obj.cancelCount)
                setResignCount(obj.resignCount)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/CustomerPositionAdd/");
    }

    function toReserve() {
        var cs = CASE_STATUS_RESERVE
        setCaseStatus(cs)
        var mReqRecruitmentPerformanceContractorRelatedList = new ReqRecruitmentPerformanceContractorRelatedList({
            companyId, departmentId, caseOwner, caseStatus: cs, start: 0, limit
        })
        toSearch({ item: mReqRecruitmentPerformanceContractorRelatedList })
    }

    function toOnBoard() {
        var cs = CASE_STATUS_ONBOARD
        setCaseStatus(cs)
        var mReqRecruitmentPerformanceContractorRelatedList = new ReqRecruitmentPerformanceContractorRelatedList({
            companyId, departmentId, caseOwner, caseStatus: cs, start: 0, limit
        })
        toSearch({ item: mReqRecruitmentPerformanceContractorRelatedList })
    }

    function toResign() {
        var cs = CASE_STATUS_RESIGN
        setCaseStatus(cs)
        var mReqRecruitmentPerformanceContractorRelatedList = new ReqRecruitmentPerformanceContractorRelatedList({
            companyId, departmentId, caseOwner, caseStatus: cs, start: 0, limit
        })
        toSearch({ item: mReqRecruitmentPerformanceContractorRelatedList })
    }

    var superTitle = caseOwnerName
    var title = '關係人列表'
    var content =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <SingleButton name={"預定中 " + reserveCount} action={toReserve} />
                        <SingleButton name={"現存 " + onBoardCount} action={toOnBoard} />
                        <SingleButton name={"剛離職 " + resignCount} color={"danger"} action={toResign} />
                    </div>
                </div>

            </div>
            <Space />
            <RecruitmentPerformanceContractorRelatedListBox list={recruitmentPerformanceContractorRelatedList} srl={setRecruitmentPerformanceContractorRelatedList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <RecruitmentPerformanceContractor id={id} status={RP_STATUS_CASEOWNER} />
            <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}

function RecruitmentPerformanceContractorRelatedListBox({ list, srl, count, page, sp }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        // console.log(list)
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentPerformanceContractorRelatedBox key={list[i].recruitmentContractorId} item={list[i]} />)
            } else {
                itemList.push(<RecruitmentPerformanceContractorRelatedBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-2">姓名</th>
                                    {/* <th className="text-center sorting col-sm-1">年齡</th>
                                    <th className="text-center sorting col-sm-1">性別</th> */}
                                    <th className="text-center sorting col-sm-2">廠商</th>
                                    <th className="text-center sorting col-sm-4">職缺</th>
                                    <th className="text-center sorting col-sm-2">日期</th>
                                    <th className="text-center sorting col-sm-2">案件狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentPerformanceContractorRelatedBox({ item }) {
    const [mItem, setItem] = useState({})
    const [companyId] = useState(getUserInfoCompanyId())
    const [recruitmentContractorId, setRecruitmentContractorId] = useState("")

    const [caseContractor, setCaseContractor] = useState("")
    const [caseContractorName, setCaseContractorName] = useState("")
    const [caseCompanyName, setCaseCompanyName] = useState("")
    const [caseCustomerPosition, setCaseCustomerPosition] = useState("")
    const [caseInfo, setCaseInfo] = useState(new ReqRecruitmentContractorCaseInfo({}))
    const [caseStatus, setCaseStatus] = useState("")
    const [caseStatusDate, setCaseStatusDate] = useState("")
    const [caseStatusString, setCaseStatusString] = useState("")

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setRecruitmentContractorId(item.recruitmentContractorId)
            setItem(item)
            setCaseContractor(item.caseContractor)
            setCaseContractorName(item.caseContractorName)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            // console.log(mReqRecruitmentContractorCaseInfo)
            setCaseInfo(mReqRecruitmentContractorCaseInfo)

            setCaseCompanyName(mReqRecruitmentContractorCaseInfo.caseCompanyName)
            setCaseCustomerPosition(mReqRecruitmentContractorCaseInfo.caseCustomerPosition)

            var caseStatusString = ""
            var caseStatusDate = ""
            if (item.caseStatus === CASE_STATUS_RESERVE) {
                caseStatusString = "預定中"
                caseStatusDate = "預定日" + moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY/MM/DD')
            } else if (item.caseStatus === CASE_STATUS_ONBOARD) {
                caseStatusString = "已上工"
                caseStatusDate = "上工日" + moment(mReqRecruitmentContractorCaseInfo.caseOnBoardDate).format('YYYY/MM/DD')
            } else if (item.caseStatus === CASE_STATUS_RESIGN) {
                caseStatusString = "已離職"
                caseStatusDate = "下工日" + moment(mReqRecruitmentContractorCaseInfo.caseResignDate).format('YYYY/MM/DD')
            }
            setCaseStatus(item.caseStatus)
            setCaseStatusString(caseStatusString)
            setCaseStatusDate(caseStatusDate)
        }
        // console.log(caseStatusDate)

        // const startDate = moment(item.birthday);
        // const endDate = moment(new Date());
        // const age = endDate.diff(startDate, 'years');
        // setAge(age)
        // setSex(item.sex === "1" ? "男" : item.sex === "1" ? "女" : "")

        // if (item.job) {
        //     setJobInfo(<a href="#A" onClick={e => toDetail()}>
        //         {job}
        //         {item !== undefined ? "/" : <></>}
        //         {shift}
        //         {item !== undefined ? "/" : <></>}
        //         {getItemsInfo({ items: WageType_Arr, val: wageType })}
        //     </a>)
        // }

        // setCompanyName(item.companyName)
        // setJob(item.job)
        // setShift(item.shift)
        // setWageType(item.wageType)
        // setStatusDeta(item.statusDate)
        // setStatus(item.status)
    }, [item])

    // function toDetail() {
    //     var tokenId = uuid(128, 64)
    //     setVal2Token("caseContractor", caseContractor, tokenId)
    //     window.open("/RecruitmentContractorStatusDetail/" + tokenId, "_blank");
    // }

    // function toSOP() {
    //     console.log(caseStatus)
    //     var tokenId = uuid(128, 64)
    //     setVal2Token("recruitmentContractorId", recruitmentContractorId, tokenId)
    //     switch (caseStatus) {
    //         case CASE_STATUS_RESERVE:
    //             window.open("/IsOrNotOnboardSOP/" + tokenId, "_blank");
    //             break;
    //         case CASE_STATUS_ONBOARD:
    //             window.open("/ResignSOP/" + tokenId, "_blank");
    //             break;
    //         default:
    //             break;
    //     }
    // }
    return (
        <tr role="row">
            <td className="text-center">
                <SingleLink link={caseStatus === CASE_STATUS_RESERVE ? "IsOrNotOnboardSOP" : caseStatus === CASE_STATUS_ONBOARD ? "ResignSOP" : "ReserveSOP"}
                    name={caseContractorName}
                    Key={"recruitmentContractorId"}
                    val={recruitmentContractorId} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toSOP()}>{caseContractorName}</a></td> */}
            {/* <td className="text-center"><a href="#A" onClick={e => toIsOrNotOnboardSOP()}>{age}</a></td>
            <td className="text-center">{sex}</td> */}
            <td className="text-center">{caseCompanyName}</td>
            <td className="text-center">{caseCustomerPosition}&nbsp;</td>
            <td className="text-center">{caseStatusDate}</td>
            <td className="text-center"><span className="text-info">{caseStatusString}</span></td>
        </tr>
    )
}
